import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import Aboutalumniassociaton from "../pages/aboutalumniassociation";
import Aboutdepartment from "../pages/Aboutdepartment";
import Headsofthedepartment from "../pages/Headsofthedepartment";
import Alumnicommitee from "../pages/Alumnicommitee";
import Gallery from "../pages/Gallery";
import Museum from "../pages/Museum";
import Ijcapjournals from "../pages/Ijcapjournals";
import Ijcapsociety from "../pages/Ijcapsociety";
import Alumniregistration from "../pages/Alumniregistration";
import MSczoology from "../pages/MSczoology";
import MSczoologyinnerpage from "../pages/MSczoologyinnerpage";
import Events from "../pages/Events";
import Contactus from "../pages/Contactus";
import Login from "../admin/Pages/Login";
import AdminLayout from "../admin/Components/AdminLayout";
import Dashboard from "../admin/Pages/Dashboard";

import CommitteeMembers from "../admin/Pages/CommitteeMembers";
import AlumniCourses from "../admin/Pages/AlumniCourses";
import IjcapJournalsAdmin from "../admin/Pages/IjcapJournalsAdmin";
import IjcapSocietyAdmin from "../admin/Pages/IjcapSocietyAdmin";
import GalleryAdmin from "../admin/Pages/GalleryAdmin";
import EventsAdmin from "../admin/Pages/EventsAdmin";
import RegistrationListAdmin from "../admin/Pages/RegistrationListAdmin";

const Allroutes = () => {
    return (
        <Router basename={'/'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/about" element={<MainLayout><AboutUs /></MainLayout>} />
                <Route exact path="/aboutdepartment" element={<MainLayout><Aboutdepartment /></MainLayout>} />
                <Route exact path="/aboutalumniassociaton" element={<MainLayout><Aboutalumniassociaton /></MainLayout>} />
                <Route exact path="/headsofthedepartment" element={<MainLayout><Headsofthedepartment /></MainLayout>} />
                <Route exact path="/alumnicommitee" element={<MainLayout><Alumnicommitee /></MainLayout>} />
                <Route exact path="/gallery" element={<MainLayout><Gallery /></MainLayout>} />
                <Route exact path="/museum" element={<MainLayout>< Museum /></MainLayout>} />
                <Route exact path="/ijcapsociety" element={<MainLayout>< Ijcapsociety /></MainLayout>} />
                <Route exact path="/alumniregistration" element={<MainLayout>< Alumniregistration /></MainLayout>} />
                <Route exact path="/ijcapjournals" element={<MainLayout>< Ijcapjournals /></MainLayout>} />

                {/* <Route exact path="/m-sc-zoology" element={<MainLayout>< MSczoology /></MainLayout>} /> */}
                <Route exact path="/course/:courseslug" element={<MainLayout>< MSczoology /></MainLayout>} />

                {/* <Route exact path="/msczoologyinnerpage" element={<MainLayout><  MSczoologyinnerpage/></MainLayout>} /> */}
                <Route exact path="/course/:courseslug/:year" element={<MainLayout>< MSczoologyinnerpage /></MainLayout>} />

                <Route exact path="/events" element={<MainLayout>< Events/></MainLayout>} />
                <Route exact path="/contactus" element={<MainLayout><  Contactus/></MainLayout>} />

                <Route exact path="/contactus" element={<MainLayout><  Contactus/></MainLayout>} />
               
                
                <Route exact path="/admin" element={<Login />} />
                <Route exact path="/admin/login" element={<Login />} />
                <Route exact path="/admin/dashboard" element={<AdminLayout title={'Dashboard'}><Dashboard /></AdminLayout>} />
                <Route exact path="/admin/alumni-commitee" element={<AdminLayout title={'Alumni Commitee Members'}><CommitteeMembers /></AdminLayout>} />
                <Route exact path="/admin/alumni-courses" element={<AdminLayout title={'Alumni Courses'}><AlumniCourses /></AdminLayout>} />
                <Route exact path="/admin/ijcap-journals" element={<AdminLayout title={'Ijcap Journals'}><IjcapJournalsAdmin /></AdminLayout>} />
                <Route exact path="/admin/ijcap-society" element={<AdminLayout title={'Ijcap Society'}><IjcapSocietyAdmin /></AdminLayout>} />
                <Route exact path="/admin/gallery" element={<AdminLayout title={'Gallery'}><GalleryAdmin /></AdminLayout>} />
                <Route exact path="/admin/events" element={<AdminLayout title={'Events'}><EventsAdmin /></AdminLayout>} />
                <Route exact path="/admin/alumni-registration" element={<AdminLayout title={'Registration List'}><RegistrationListAdmin /></AdminLayout>} />

            </Routes>
        </Router>
    )
}

export default Allroutes;